export const Twitter = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 333333 333333'
			width={size}
			height={size}
			className={className}
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			imageRendering='optimizeQuality'
			fillRule='evenodd'
			clipRule='evenodd'
		>
			<title>Twitter</title>
			<path
				d='M166667 0c46023 0 87690 18655 117851 48816s48816 71828 48816 117851-18655 87690-48816 117851-71828 48816-117851 48816-87690-18655-117851-48816S0 212690 0 166667 18655 78977 48816 48816 120644 0 166667 0zm77224 118769c-5678 2539-11795 4226-18182 4979 6544-3919 11549-10130 13937-17524-6117 3617-12914 6270-20117 7690-5792-6154-14018-9979-23131-9979-17497 0-31664 14175-31664 31661 0 2468 274 4882 810 7211-26328-1335-49670-13939-65294-33115-2803 4835-4286 10333-4286 15924v4c0 10980 5574 20691 14081 26354-5191-154-10073-1602-14360-3947v396c0 15355 10914 28167 25416 31063-2657 722-5461 1120-8351 1120-2046 0-4019-211-5980-567 4050 12575 15743 21743 29589 22009-10857 8506-24492 13570-39357 13570-2566 0-5065-157-7561-456 14052 9016 30698 14238 48580 14238 58261 0 90147-48281 90147-90144 0-1391-31-2739-89-4102 6188-4426 11552-10013 15799-16372l15-15-3 2zm29405-58731c-27287-27287-64987-44165-106628-44165-41642 0-79341 16878-106628 44165s-44165 64987-44165 106628c0 41642 16878 79341 44165 106628s64987 44165 106628 44165c41642 0 79341-16878 106628-44165s44165-64987 44165-106628c0-41642-16878-79341-44165-106628z'
				fill='#1da1f2'
				fillRule='nonzero'
			/>
		</svg>
	);
};

export const Linkedin = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 333333 333333'
			width={size}
			height={size}
			className={className}
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			imageRendering='optimizeQuality'
			fillRule='evenodd'
			clipRule='evenodd'
		>
			<title>Linkedin</title>
			<path
				d='M166667 0c46023 0 87690 18655 117851 48816s48816 71828 48816 117851-18655 87690-48816 117851-71828 48816-117851 48816-87690-18655-117851-48816S0 212690 0 166667 18655 78977 48816 48816 120644 0 166667 0zm-18386 141742h26667v13671l386 1c3714-6663 12794-13671 26335-13671 28159-1 33367 17523 33367 40319v46437l-27811 1v-41165c0-9813-204-22446-14460-22446-14481 0-16699 10682-16699 21731v41880h-27786v-86757zm-19280-24100c0 7983-6478 14461-14461 14461-7982 0-14463-6478-14463-14461s6480-14460 14463-14460 14461 6478 14461 14460zm-28924 24100h28924v86757h-28924v-86757zm173218-81703c-27287-27287-64987-44165-106628-44165-41642 0-79341 16878-106628 44165s-44165 64987-44165 106628c0 41642 16878 79341 44165 106628s64987 44165 106628 44165c41642 0 79341-16878 106628-44165s44165-64987 44165-106628c0-41642-16878-79341-44165-106628z'
				fill='#0077b5'
				fillRule='nonzero'
			/>
		</svg>
	);
};

export const Instagram = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			className={className}
			viewBox='0 0 333333 333333'
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			imageRendering='optimizeQuality'
			fillRule='evenodd'
			clipRule='evenodd'
		>
			<defs>
				<linearGradient
					id='a'
					gradientUnits='userSpaceOnUse'
					x1='126963'
					y1='323675'
					x2='206370'
					y2='9655.51'
				>
					<stop offset='0' stopColor='#f58529' />
					<stop offset='.129' stopColor='#feda77' />
					<stop offset='.431' stopColor='#dd2a7b' />
					<stop offset='.741' stopColor='#8134af' />
					<stop offset='1' stopColor='#515bd4' />
				</linearGradient>
			</defs>
			<title>Instagram</title>
			<path
				d='M129816 80249h73706c27678 0 50313 22355 50313 49665v73506c0 27317-22635 49663-50313 49663h-73706c-27680 0-50317-22348-50317-49663v-73508c0-27308 22638-49663 50317-49663zM166667 0c46024 0 87691 18656 117851 48816 30159 30160 48816 71827 48816 117851 0 46020-18656 87689-48816 117849-30161 30159-71830 48816-117851 48816-46020 0-87689-18657-117851-48816C18657 254356 0 212687 0 166667S18656 78978 48816 48816C78977 18657 120646 0 166667 0zm104924 61742c-26849-26849-63948-43459-104924-43459-40974 0-78074 16610-104924 43459-26849 26850-43459 63950-43459 104924 0 40976 16610 78074 43459 104923 26850 26849 63950 43459 104924 43459s78074-16610 104924-43459c26849-26849 43459-63947 43459-104923s-16610-78076-43459-104924zm-105394 58260c26896 0 48723 21826 48723 48724 0 26900-21827 48723-48723 48723-26904 0-48727-21823-48727-48723 0-26898 21823-48724 48727-48724zm0 16457c17811 0 32267 14453 32267 32267 0 17815-14456 32271-32267 32271-17817 0-32270-14456-32270-32271 0-17814 14453-32267 32270-32267zm47139-23209c4368 0 7911 3542 7911 7908 0 4369-3543 7911-7911 7911-4367 0-7908-3542-7908-7911 0-4367 3542-7908 7908-7908zm-77498-18883h61667c23156 0 42094 18843 42094 41872v61975c0 23027-18937 41867-42094 41867l-61667 2c-23154 0-42095-18841-42095-41867v-61978c0-23027 18941-41870 42095-41870z'
				fill='url(#a)'
			/>
		</svg>
	);
};

export const Github = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			className={className}
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			imageRendering='optimizeQuality'
			fillRule='evenodd'
			clipRule='evenodd'
			viewBox='0 0 640 640'
		>
			<path d='M319.988 7.973C143.293 7.973 0 151.242 0 327.96c0 141.392 91.678 261.298 218.826 303.63 16.004 2.964 21.886-6.957 21.886-15.414 0-7.63-.319-32.835-.449-59.552-89.032 19.359-107.8-37.772-107.8-37.772-14.552-36.993-35.529-46.831-35.529-46.831-29.032-19.879 2.209-19.442 2.209-19.442 32.126 2.245 49.04 32.954 49.04 32.954 28.56 48.922 74.883 34.76 93.131 26.598 2.882-20.681 11.15-34.807 20.315-42.803-71.08-8.067-145.797-35.516-145.797-158.14 0-34.926 12.52-63.485 32.965-85.88-3.33-8.078-14.291-40.606 3.083-84.674 0 0 26.87-8.61 88.029 32.8 25.512-7.075 52.878-10.642 80.056-10.76 27.2.118 54.614 3.673 80.162 10.76 61.076-41.386 87.922-32.8 87.922-32.8 17.398 44.08 6.485 76.631 3.154 84.675 20.516 22.394 32.93 50.953 32.93 85.879 0 122.907-74.883 149.93-146.117 157.856 11.481 9.921 21.733 29.398 21.733 59.233 0 42.792-.366 77.28-.366 87.804 0 8.516 5.764 18.473 21.992 15.354 127.076-42.354 218.637-162.274 218.637-303.582 0-176.695-143.269-319.988-320-319.988l-.023.107z' />
		</svg>
	);
};

export const Email = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			className={className}
			viewBox='0 0 122.88 122.88'
		>
			<title>Email</title>
			<path
				d='M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0ZM32.22,79.39,52.1,59.46,32.22,43.25V79.39ZM54.29,61.24,33.79,81.79H88.91L69.33,61.24l-6.46,5.51h0a1.42,1.42,0,0,1-1.8,0l-6.78-5.53Zm17.18-1.82L90.66,79.55V43.07L71.47,59.42ZM34,41.09l27.9,22.76L88.65,41.09Zm65.4-17.64a53.72,53.72,0,1,0,15.74,38,53.56,53.56,0,0,0-15.74-38Z'
				fill='#0078d4'
			/>
		</svg>
	);
};

export const TopWave = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			className={className}
			viewBox='0 0 1440 320'
		>
			<title>Layer</title>
			<path
				fill='#0099ff'
				fillOpacity='1'
				d='M0,64L80,58.7C160,53,320,43,480,74.7C640,107,800,181,960,192C1120,203,1280,149,1360,122.7L1440,96L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z'
			></path>
		</svg>
	);
};

export const BottomWave = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			className={className}
			viewBox='0 0 1440 320'
		>
			<title>Layer</title>
			<path
				fill='#0099ff'
				fill-opacity='1'
				d='M0,64L80,53.3C160,43,320,21,480,64C640,107,800,213,960,250.7C1120,288,1280,256,1360,240L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z'
			></path>
		</svg>
	);
};

export const Diagram = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 576 512'
			width={size}
			height={size}
			className={className}
		>
			<path d='M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z' />
		</svg>
	);
};

export const ExternalLink = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 448 512'
			width={size}
			height={size}
			className={className}
		>
			<path d='M288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L169.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H288zM80 64C35.8 64 0 99.8 0 144V400c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z' />
		</svg>
	);
};

export const Code = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 640 512'
			width={size}
			height={size}
			className={className}
		>
			<path d='M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z' />
		</svg>
	);
};

export const ComingSoon = ({ className, size = 24 }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 104.69 122.88'
			x='0px'
			y='0px'
			xmlSpace='preserve'
			width={size}
			height={size}
			className={className}
		>
			<g>
				<path d='M2.12,46.11c0.41-5.33,1.59-10.36,3.54-15.08c2.47-5.96,6.16-11.39,11.05-16.28C21.6,9.86,27.03,6.17,33,3.7 C38.95,1.24,45.4,0,52.34,0c6.94,0,13.39,1.24,19.35,3.7c5.97,2.47,11.4,6.15,16.29,11.05c4.89,4.89,8.58,10.32,11.04,16.29 c1.96,4.73,3.14,9.77,3.55,15.11c-0.62-0.27-1.27-0.48-1.94-0.64c-1.01-0.26-2.06-0.41-3.15-0.46c-0.46-4.29-1.47-8.33-3.04-12.13 c-2.21-5.33-5.54-10.21-9.98-14.66c-4.45-4.44-9.33-7.77-14.65-9.98c-5.33-2.21-11.15-3.31-17.46-3.31 c-6.31,0-12.13,1.11-17.46,3.31c-5.33,2.2-10.21,5.53-14.66,9.98c-4.44,4.45-7.77,9.34-9.98,14.66c-1.57,3.79-2.59,7.83-3.04,12.12 c-0.81,0.03-1.62,0.13-2.41,0.28C3.85,45.51,2.96,45.77,2.12,46.11L2.12,46.11z M23.75,95.37h-9.25v-2.83 c0-1.33-0.12-2.17-0.36-2.54c-0.23-0.36-0.63-0.53-1.18-0.53c-0.6,0-1.05,0.24-1.36,0.73c-0.31,0.49-0.46,1.22-0.46,2.22 c0,1.27,0.17,2.23,0.52,2.89c0.33,0.65,1.27,1.42,2.82,2.34c4.43,2.63,7.22,4.79,8.37,6.48c1.15,1.69,1.73,4.4,1.73,8.16 c0,2.73-0.33,4.74-0.96,6.03c-0.64,1.29-1.87,2.37-3.7,3.25c-1.83,0.88-3.96,1.32-6.39,1.32c-2.67,0-4.94-0.51-6.82-1.52 c-1.89-1.01-3.13-2.3-3.7-3.85c-0.58-1.56-0.87-3.78-0.87-6.65v-2.5h9.24v4.65c0,1.44,0.13,2.36,0.39,2.77 c0.27,0.41,0.72,0.61,1.38,0.61s1.16-0.26,1.48-0.78c0.32-0.52,0.48-1.29,0.48-2.31c0-2.26-0.31-3.73-0.92-4.43 c-0.63-0.7-2.18-1.85-4.66-3.47c-2.48-1.64-4.12-2.83-4.93-3.58c-0.8-0.74-1.47-1.77-1.99-3.08c-0.53-1.31-0.79-2.98-0.79-5.01 c0-2.93,0.37-5.08,1.12-6.43c0.75-1.36,1.95-2.41,3.62-3.18c1.67-0.76,3.69-1.15,6.06-1.15c2.59,0,4.79,0.42,6.61,1.25 c1.83,0.84,3.04,1.9,3.62,3.17c0.59,1.26,0.89,3.42,0.89,6.46V95.37L23.75,95.37z M50.44,106.2c0,3.85-0.09,6.57-0.27,8.16 c-0.18,1.61-0.75,3.07-1.7,4.39c-0.95,1.32-2.24,2.34-3.86,3.05c-1.63,0.71-3.52,1.07-5.67,1.07c-2.05,0-3.9-0.34-5.52-1.01 c-1.64-0.67-2.95-1.67-3.94-3.01c-0.99-1.34-1.6-2.81-1.78-4.38c-0.18-1.57-0.28-4.34-0.28-8.28v-6.55c0-3.85,0.09-6.57,0.28-8.18 c0.18-1.6,0.74-3.06,1.7-4.39c0.95-1.32,2.24-2.34,3.86-3.05c1.63-0.71,3.52-1.06,5.68-1.06c2.05,0,3.89,0.34,5.52,1.01 c1.63,0.67,2.95,1.67,3.94,3.01c0.99,1.34,1.58,2.8,1.77,4.38c0.18,1.57,0.28,4.33,0.28,8.28V106.2L50.44,106.2z M40.49,93.62 c0-1.78-0.1-2.92-0.3-3.42c-0.19-0.49-0.6-0.74-1.22-0.74c-0.52,0-0.92,0.2-1.19,0.6c-0.28,0.39-0.42,1.58-0.42,3.56v17.88 c0,2.22,0.09,3.6,0.27,4.12c0.19,0.52,0.61,0.78,1.27,0.78c0.68,0,1.11-0.3,1.31-0.89c0.18-0.61,0.28-2.04,0.28-4.29V93.62 L40.49,93.62z M76.91,106.2c0,3.85-0.09,6.57-0.27,8.16c-0.19,1.61-0.75,3.07-1.7,4.39c-0.96,1.32-2.25,2.34-3.87,3.05 c-1.62,0.71-3.52,1.07-5.67,1.07c-2.05,0-3.89-0.34-5.52-1.01c-1.64-0.67-2.95-1.67-3.94-3.01c-0.99-1.34-1.59-2.81-1.78-4.38 c-0.18-1.57-0.28-4.34-0.28-8.28v-6.55c0-3.85,0.09-6.57,0.27-8.18c0.18-1.6,0.74-3.06,1.7-4.39c0.95-1.32,2.25-2.34,3.87-3.05 c1.62-0.71,3.51-1.06,5.68-1.06c2.05,0,3.89,0.34,5.52,1.01c1.63,0.67,2.95,1.67,3.94,3.01c0.99,1.34,1.59,2.8,1.77,4.38 c0.18,1.57,0.28,4.33,0.28,8.28V106.2L76.91,106.2z M66.95,93.62c0-1.78-0.1-2.92-0.3-3.42c-0.2-0.49-0.6-0.74-1.21-0.74 c-0.53,0-0.92,0.2-1.19,0.6c-0.28,0.39-0.42,1.58-0.42,3.56v17.88c0,2.22,0.09,3.6,0.28,4.12c0.18,0.52,0.6,0.78,1.27,0.78 c0.68,0,1.11-0.3,1.3-0.89c0.18-0.61,0.28-2.04,0.28-4.29V93.62L66.95,93.62z M102.85,83.79v38.28h-8.72l-5.18-17.4v17.4h-8.32 V83.79h8.32l5.59,17.24V83.79H102.85L102.85,83.79z M16.06,62.52H9.27v-4.55c0-1.32-0.07-2.15-0.22-2.48C8.9,55.17,8.58,55,8.08,55 c-0.56,0-0.92,0.2-1.06,0.6c-0.15,0.4-0.23,1.26-0.23,2.58v12.14c0,1.27,0.08,2.1,0.23,2.49c0.15,0.39,0.49,0.58,1.02,0.58 c0.51,0,0.84-0.19,0.99-0.58c0.16-0.38,0.24-1.3,0.24-2.73V66.8h6.79v1.01c0,2.7-0.2,4.62-0.57,5.75 c-0.38,1.13-1.23,2.12-2.54,2.97c-1.31,0.85-2.92,1.28-4.83,1.28c-1.99,0-3.63-0.36-4.93-1.09C1.9,76,1.05,75,0.63,73.73 C0.21,72.46,0,70.54,0,67.98v-7.63c0-1.88,0.06-3.29,0.19-4.24c0.13-0.94,0.51-1.85,1.16-2.72c0.64-0.87,1.52-1.56,2.66-2.06 c1.13-0.5,2.44-0.75,3.91-0.75c2,0,3.65,0.39,4.96,1.16c1.3,0.78,2.15,1.74,2.57,2.9c0.41,1.16,0.62,2.96,0.62,5.4V62.52 L16.06,62.52z M34.3,66.43c0,2.63-0.06,4.49-0.18,5.58c-0.13,1.09-0.51,2.09-1.16,3c-0.65,0.9-1.54,1.59-2.64,2.08 c-1.11,0.48-2.4,0.73-3.87,0.73c-1.39,0-2.65-0.23-3.77-0.69c-1.12-0.46-2.01-1.14-2.69-2.06c-0.67-0.91-1.08-1.91-1.21-2.98 c-0.13-1.07-0.19-2.96-0.19-5.65v-4.46c0-2.63,0.06-4.49,0.18-5.58c0.12-1.09,0.51-2.09,1.16-2.99c0.65-0.91,1.54-1.6,2.64-2.08 c1.11-0.48,2.39-0.73,3.87-0.73c1.4,0,2.66,0.23,3.77,0.69c1.11,0.46,2.01,1.14,2.69,2.06c0.68,0.91,1.08,1.91,1.21,2.98 c0.12,1.07,0.19,2.96,0.19,5.65V66.43L34.3,66.43z M27.51,57.85c0-1.22-0.06-1.99-0.2-2.33C27.17,55.18,26.9,55,26.48,55 c-0.36,0-0.62,0.14-0.81,0.41c-0.19,0.27-0.29,1.08-0.29,2.43v12.19c0,1.52,0.07,2.46,0.19,2.81c0.13,0.36,0.41,0.53,0.86,0.53 c0.47,0,0.77-0.2,0.89-0.61c0.12-0.42,0.19-1.39,0.19-2.93V57.85L27.51,57.85z M58.09,51.14v26.12h-5.93V59.62l-2.38,17.64h-4.21 l-2.5-17.23v17.23h-5.94V51.14h8.79c0.26,1.57,0.53,3.42,0.82,5.55l0.93,6.65l1.55-12.2H58.09L58.09,51.14z M67.89,51.14v26.12 H61.1V51.14H67.89L67.89,51.14z M86.08,51.14v26.12h-5.96l-3.54-11.87v11.87h-5.68V51.14h5.68L80.4,62.9V51.14H86.08L86.08,51.14z M104.69,60.75h-6.79v-2.37c0-1.49-0.06-2.43-0.19-2.81C97.57,55.19,97.26,55,96.78,55c-0.42,0-0.71,0.16-0.86,0.49 c-0.15,0.33-0.23,1.15-0.23,2.48v12.53c0,1.18,0.07,1.95,0.23,2.32c0.14,0.37,0.45,0.55,0.9,0.55c0.5,0,0.84-0.21,1.02-0.62 c0.18-0.43,0.27-1.24,0.27-2.46v-3.1h-1.38v-3.97h7.95v14.02h-4.27l-0.63-1.87c-0.46,0.81-1.04,1.42-1.74,1.82 c-0.71,0.4-1.54,0.61-2.5,0.61c-1.14,0-2.21-0.28-3.2-0.83c-0.99-0.55-1.75-1.24-2.27-2.06c-0.52-0.82-0.84-1.67-0.97-2.58 c-0.13-0.9-0.2-2.25-0.2-4.04v-7.76c0-2.5,0.13-4.31,0.4-5.43c0.27-1.13,1.04-2.17,2.32-3.11c1.27-0.94,2.93-1.42,4.95-1.42 c1.99,0,3.64,0.41,4.95,1.23c1.31,0.83,2.17,1.79,2.57,2.92c0.4,1.12,0.6,2.75,0.6,4.9V60.75L104.69,60.75z M52.28,14.03l5.06,8.74 h-2.89v16.22h11.78V36.1l8.74,5.05l-7.66,4.43h-1.08v-2.27l-16.09,0.01v-4.27h-0.01V22.77h-2.89L52.28,14.03L52.28,14.03 L52.28,14.03z' />
			</g>
		</svg>
	);
};
